document.addEventListener('DOMContentLoaded', function() {
  const LOCAL_STORAGE_KEY = 'shopify_wishlist';

  // Get current wishlist from local storage
  function getWishlist() {
    const wishlist = localStorage.getItem(LOCAL_STORAGE_KEY);
    return wishlist ? JSON.parse(wishlist) : [];
  }

  // Update local storage
  function setWishlist(wishlist) {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(wishlist));
    updateAllButtons(); // Visually update hearts on the page
  }

  // Toggle item in wishlist
  function toggleWishlist(handle) {
    let wishlist = getWishlist();
    if (wishlist.includes(handle)) {
      wishlist = wishlist.filter(item => item !== handle); // Remove it
    } else {
      wishlist.push(handle); // Add it
    }
    setWishlist(wishlist);
  }

  // Update the UI of all buttons on the page
  function updateAllButtons() {
    const wishlist = getWishlist();
    const buttons = document.querySelectorAll('.wishlist-btn');

    buttons.forEach(button => {
      const handle = button.getAttribute('data-product-handle');
      const emptyHeart = button.querySelector('.empty');
      const filledHeart = button.querySelector('.filled');

      if (wishlist.includes(handle)) {
        emptyHeart.style.display = 'none';
        filledHeart.style.display = 'block';
      } else {
        emptyHeart.style.display = 'block';
        filledHeart.style.display = 'none';
      }
    });
  }

  // Attach click listeners to buttons
  document.body.addEventListener('click', function(e) {
    const btn = e.target.closest('.wishlist-btn');
    if (!btn) return;

    e.preventDefault();
    const handle = btn.getAttribute('data-product-handle');
    if (handle) {
      toggleWishlist(handle);
    }
  });

  // Run on page load to set initial states
  updateAllButtons();
});